import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size, width } from '@twistopayments/design-system/styles'

export const footer = (theme: Theme) => css`
  position: relative;
  padding: ${size[40]} 0;
  background-color: ${theme.palette.background.accent};

  ${breakpoint.up('smMd')} {
    padding: ${size[60]} 0 ${size[36]};
  }

  ${breakpoint.up('md')} {
    padding: ${size[90]} 0 ${size[56]};
  }
`

export const container = css`
  max-width: ${width.container.large};
  padding: 0 ${size[20]};
  margin: 0 auto;
`

export const social = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5em;

  ${breakpoint.up('smMd')} {
    margin-bottom: 3em;
  }
`

export const logo = css`
  height: ${size[32]};

  ${breakpoint.up('smMd')} {
    height: ${size[48]};
  }
`

export const columns = css`
  display: flex;
  flex-direction: column;

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    justify-content: space-between;
    gap: ${size[24]};
  }
`

export const column = (theme: Theme) => css`
  width: 18%;
  display: flex;
  flex-direction: column;

  span {
    color: ${theme.palette.tertiary.upperMediumContrast};
    font-weight: 400;
  }

  li:first-child {
    font-size: calc(1rem / 16 * 20);
    margin: 0 auto 20px;
    padding: 0;
    font-weight: 600;
    color: ${theme.palette.text.title};
    line-height: 1.5;
  }
`

export const copyright = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;

  li {
    margin: 0;
    padding: 0;
  }

  a span {
    color: ${theme.palette.ghost.mediumContrast};
    text-align: center;
    font-size: 16px;
  }

  ${breakpoint.up('smMd')} {
    margin-top: 3em;
    flex-direction: row;
  }
`

export const socialMediaIcon = css`
  padding: 0 10px;

  &:hover {
    background-color: transparent;
  }
`

export const copyrightText = (theme: Theme) => css`
  color: ${theme.palette.ghost.mediumContrast};
  margin: 0;
  font-size: 16px;
`

export const accordion = css`
  font-weight: 600;
  line-height: 1.5;
  font-size: 18px;
  border-bottom: 1px solid rgba(130, 139, 153, 0.25);

  &:nth-last-child(1) {
    border-bottom: none;
  }

  span {
    margin-bottom: ${size[16]};
  }
`

export const open = css`
  &::after {
    display: none;
  }
`

export const accordionName = css`
  position: relative;

  &::before,
  &::after {
    content: '';
    background: #828b99;
    height: 2px;
    width: 14px;
    border-radius: 2px;
    display: block;
    position: absolute;
    top: 50%;
    right: 10px;
  }

  &::after {
    transform: rotateZ(90deg);
  }
`

export const accordionLinks = css`
  li {
    padding: 0;
  }

  span {
    color: #5c5c5c;
    font-weight: 400;
  }
`

export const widget = (theme: Theme) => css`
  ${breakpoint.up('smMd')} {
    background-color: ${theme.palette.primary.lowContrast};
    border-radius: ${theme.borderRadius.md};
    margin: 0;
    padding: ${size[32]};
    width: 28%;
  }
`
